import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip
} from '@mui/material';

const LOCATION_OPTIONS = [
  { value: 'L', label: 'mainland' },
  { value: 'M', label: 'mid lake' },
  { value: 'C', label: 'connected' },
  { value: 'S', label: 'shoreline' },
  { value: 'I', label: 'island' },
  { value: 'Z', label: 'isolated' },
  { value: 'O', label: 'open water' },
  { value: 'B', label: 'mouths of' },
  { value: 'E', label: 'edges of' },
  { value: 'A', label: 'anywhere' },
  { value: 'G', label: 'gradual' },
  { value: 'D', label: 'multi-dimension' }
];

const ALL_SPOT_TYPES = [
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Boat Landing"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow Bays with Dead Weeds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Small connected Inkpot lakes"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Large Mud Flats Adjacent to Spawning Areas"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shoreline Related Structure (Travel Routes)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Thoroughfares and Creeks"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Wild Rice Beds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Soft Bottom with Wood"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Sunny Shores (look to the north)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Silty Bays"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Emergent Vegetation Beds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Stream and Creek In-Flows"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Varying Water Temperature Pockets"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow Neck Down Areas"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Summertime Pads"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Expansive Shallow Mud Flats"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Small Connected Inkpot Lakes"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Adjacent Points to Spawning Bays"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Green Weed Shoots at the Mouths of Bays"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Open Water over Insect Hatch Beds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow, Warm & Silty Areas with Bug Beds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Secondary Break off Rush Beds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Woody Shoreline Shallows"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow Shoreline Connected Rock Structures"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Males Hanging Around Spawning Bays"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Basin oriented bug hatch beds on soft bottom"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Top 8 ft of the water column off structure"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Side Edge of Weedy Bays"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Space above the weeds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Edge of large sand flats"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Long Weed Points"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Steep Rock Shores"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mid Lake Weed Bars (Disect It)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Weed Edges"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Steep Hard Shorelines"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Rock and Weed Combos"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mid Lake Rock Bars"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Cool Water Springs"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Timber & Cribs"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Open Water - Panfish Schooling Up"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Slop"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Inside Weed Edge (go shallow!)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Creek and River Inlets or Outlets"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Neck Down Areas & Narrows"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow Weedbeds (Grind em or Top em)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Thoroughfare Mouths"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Rock Spines and Points with a Shallow Top"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Wooded Shorelines (in tight)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Steep Rocky Shorelines"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shoreline Oriented - Very Shallow 1st-Cool Down Spots"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Honestly the fish could be almost anywhere"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Any spot that held fish in the past two months"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"If your lake stratifies, stay above the thermocline"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Wind Blown Rock Structures (BoysCamp)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Top Two Weed Beds in the Lake"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Cribs and Wood"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Structural Waysides on Travel Routes to LateFall Spots"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Out off Mouths of In-Flows"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Honestly the fish could be almost anywhere"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow Rock Points on End of Islands (Front)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Shallow Sandbars w/ Scruff or Gravel"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Cribs and Wood"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mid-Depth Flats"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Open Water - Panfish Schooling Up"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Hard-Bottom to Soft-Bottom Transition"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Main Lake Shallow Rock Bars"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mid Depth Sand or Gravel Saddles"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mud Flats with Roaming Perch Schools"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Hard Bottom Fingers"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Wood (Cribs, Busted Cribs, Logs)"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Large Mature Weedbeds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Secondary Breaks"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Prior Year Hot Spots"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deepest Spots with Hard Bottom"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Holes and Rim Ridge"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Steep Breaking Shores and Weed Walls"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mid Lake Rock Structures"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Cribs"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Wind Blown Points"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Second Break"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Hard-Bottom to Soft-Bottom Transition"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Deep Holes"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mouths of Shallow Dead Weed Bays"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Mud Basin"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Any Live Weeds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Hard to Soft Bottom Transition"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Secondary Breakline"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Dead  and Fallen Weeds"
      },
      {
         "lakeType":"ShallowStained",
         "spotTypeDesc":"Rock Points"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Boat Landing"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Shallow Bays with Dead Weeds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Entrance to Small Connected Mud Lakes"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Soft Bottom 20 - 30 ft of water (Pelagics Roaming)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Gradual Shorelines with Dead Weeds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Mouths of Thoroughfares and Creeks"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"First Break off Wild Rice or Bullrush Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Sand Bottom Shorelines (Smelt Spawn)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"North and Northeast Shorelines"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Silty Backs of Bays"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Emergent Vegetation Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Stream and Creek In-Flows"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Gradual Slope Shorelines with Dead Weeds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Neck Down Areas with Sand and Scruff Weeds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Thoroughfares"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Fairly Clean Sand Shorelines"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Small Connected Mud & Inkpot Lakes"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Adjacent Points to Spawning Bays"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Any Scruffy New Weed Growth you can find"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Open Water over Insect Hatch Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Varying Water Temperature Pockets"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Secondary Break off Rush Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Sand Shorelines with Scattered Wood"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Soft Bottom Shorelines Near Spawning Zones"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Roaming Males Hanging Around Spawning Bays"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Open Water Cisco and Whitefish Schools"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Out and Off Structure (75+ yds) during Daylight"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Edge Weedy Bays"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Rock and Weed Complex Bars (ie Bootjack)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Evening Bug Rises - Varying Depths"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Long Weed Points"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Warm Bays with Scattered Junk Weeds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Mid Lake Weed Bars"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Weed Edges"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Steep Dropping Hard Shorelines"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Rock and Weed Combos"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Mid Lake Rock Bars"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Top Five Feet over known Cisco Areas (Early Mornings)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Evening Bug Rises"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Open Water - Cisco, Whitefish, or Smelt Schools"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Sandgrass (1-3' tall in 25 fow)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Weeds with Sandgrass Fringe"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Inside Weed Edge (go shallow!)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Neck Down Areas & Narrows"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Biggest and Best Weedbeds Available"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"8 to 12 foot Sandbars with Scant Weeds or Rocks"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Rock Spines and Points (shallow on top)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Wooded Shorelines (in tight)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Gradual Slope with Scattered Chunk Rock"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Side Edges of Big Sand Flats"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Steep Rocky Shorelines"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Slow Sloping Shorelines with Gravel or Rocks"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Stay above the Thermocline (don’t go deep yet)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Edge of Shallow Weed Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Milfoil Walls (Unfortunate, but hold fish)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Open Water - Cisco, Whitefish, or Smelt Schools"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Saddles Between Islands"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Bays with Inlet Current - Mouth and Sides"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Areas Isolated from or Late into Turnover"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Edge of Shallow Weed Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Shallow Sandbars w/ Scruff or Gravel"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Mid-Depth Wood (Cribs, Busted Cribs, Logs)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Sandgrass Beds (20 - 28 ft deep)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Open Water - Cisco, Whitefish, or Smelt Schools"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Secondary Breaks (esp. off sand)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Main Lake Rock Bars"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Mid Depth Sand or Gravel Saddles"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Rocky Saddles"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Open Water over Suspended Crappies"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Wood (Cribs, Busted Cribs, Logs)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Large Mature Weedbeds Especially Points"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Secondary Breaks (esp. off sand)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Staging Cisco and Whitefish Areas"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Spots with Exposed Hard Bottom"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Holes and Rim Ridge"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Top 15 feet over Deep Basin"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Steep Rock Shorelines"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Still Green Weedbeds - Deep Edge"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Wind Blown Sand Shorelines with Weeds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Cisco and Whitefish Spawning Areas"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Wood or Broken Cribs"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Hard Bottom Flats"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Holes and Rim Ridge"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"2nd or 3rd Food Shelf"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Edge off Weed Beds"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Soft Bottom 20 - 30 ft (Pelagics Roaming)"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Secondary Breakline"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Mid Lake Rock Structure"
      },
      {
         "lakeType":"DeepClear",
         "spotTypeDesc":"Deep Scattered Timber"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Boat Landing"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep Holes off Current Edges"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Eddy below a river inflow"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Under the Chutes"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"North or Northeast Rock Walls"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Suspended out off Mouths to Spawning Bays"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Bulrush and Wild Rice Beds"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Large Sand Bays facing West or Southwest"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Open Water by Crappie Schools"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Big Shallow Bays with Weeds (s/b there)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Shallow Bays with Silt and Scruff"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Creek and River Inlets (esp. in bays)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Front Sides of Bays with Outflows"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Long Narrows with Rush or Wild Rice Beds"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Young Shoots of Coontail or Cabbage"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Cold Front Rock Point Sliders"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Isolated SxSW Facing Shallow Bays (Warming)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Some fish still back deep in bays"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Roaming Males Hanging Around Spawning Bays"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Gap between Sheer Walls and Inside Weed Edge"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Rock Points off Spawning Bays"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Shelf Below First Break off Bulrush Beds"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Suspended out off Mouth (same depth)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Green Weed Shoots at the Mouths of Bays"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Open Water near suspended Bait Schools"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep Side Shoreline of Island Strings"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Natural Steering Structure from Glaicer Cuts (Travelers)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Gap between Sheer Walls and Inside Weed Edge"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Rock Points off Spawning Bays"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Subtle Current Routes (See Winter Satelite Pics)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Chunk Rock Shorelines (Sab Beaver & Jim S)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Low and Slow Off Secondary Break (Petes)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep bug hatch beds on soft bottom?"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Cup Bays - Weeds in Back"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"X-Long Rock Points"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Saddles with Rocks or Boulder Fields"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Complex Mid-Lake Reefs with Combo Structure Types"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Windward Walls"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Neckdowns with Wind"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Open Water - Panfish Schools"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Big sprawling weed beds - if nothing else is working"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Cup Bays - Weeds in Back"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Natural Steering Structure from Glaicer Cuts (Travelers)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Saddles with Rocks or Boulder Fields"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Weed and Rock Complexes (By George)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Rocky, Mid-Lake, Island Shorelines (Shallow-Sabby)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Neckdowns with Wind"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Shorelines with downed timber"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Shoreline Oriented Flats with Chunk Rock (Bill Sandy)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Island Clusters with Complex Saddles"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Reeds with Clean Bottom, Scattered rock optimal"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Shoreline Stretches w/Weeds & Logs (Brets fiddy)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Weed and Rock Complexes (By George)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Large, Mid Lake Flats Off Islands w/ Chunk Rock"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Reed Beds (ie The Ride into Bourrows)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Shorelines with downed timber"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Open Water - Near Crappie Schools"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Island Clusters with Complex Saddles"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Natural Steering Structure from Glaicer Cuts (Travelers)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Chunk Rock Shorelines (South of Beaver)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Weed and Rock Complexes (By George)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Rocky, Mid-Lake, Island Shorelines (Shallow-Sabby)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Reed Beds (ie The Ride into Bourrows)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Neckdowns with Weeds and Wind"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Dead Weed Edges near deep water"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Neckdowns with Weeds and Wind"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Saddle Flats (ie SW Calendar Saddle)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Chunk Rock Shorelines (South of Beaver)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Tier-2 Extended Point Flats (w/ décor)Big nordys"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Large, Mid Lake Flats Off Islands w/ Chunk Rock"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Steep Breaking Shorelines with Pelagic Baitfish"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep holes in Current"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Rocky, Mid-Lake, Island Shorelines (Shallow-Sabby)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Rock Points off Ends of Long Island Strings (calendar)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Saddles (like Lost Boat)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Tier-2 Extended Point Flats (w/ décor)Big nordys"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Spines off Island Shores and Extensions"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Windy Tops of Shallow Reefs"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Steep Breaking Shorelines with Pelagic Baitfish"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep holes in Current"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Dead Weed Edges near deep water"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Large Sand Bars or Flats in 12 - 18 FOW"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Open Water Eddy Edges"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Below the Chutes"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deepest Basin in the Lake"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Side Shorelines above an Outflow (Paw Landing)"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep Side of Dead or Dying Weed Beds"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Deep holes in Current"
      },
      {
         "lakeType":"CAShallowStained",
         "spotTypeDesc":"Open Water by Crappie Schools"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Boat Landing"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep Holes off Current Edges (Escapes)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small Shallow Connected Silty Lakes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Creek and Stream Inlets (i.e. Alfred Inlet)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Classic Deep Reefs with Substrate Variation"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"2nd or 3rd Breakline off Mouth of Large Sand Bays (i.e. Timber)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Suspended in Deep Water Neck Downs"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Granite Walls with Deep Water and Baitfish"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Suspended out off Mouths to Spawning Bays"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Bays with Dead Weeds"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Bays with Silt and Scruff (NE Patsy)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Creek and Stream Inlets (i.e. Alfred Inlet)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Front and Sides of Bays with Outflows"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Long Narrows with Rush or Wild Rice Beds"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Sandy Bays with Scattered Weed Shoots"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Waterfall Inlet Bays with Reeds down shore(Dryberry)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small Connected Stained Lakes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Males Hanging Around Spawning Bays"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Rock Walls Out and Down Shore from Spawning Bays"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"West Facing Sand Bays (esp. if scruff weeds)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Rock Points off Spawning Bays"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small, Well Defined Structure Spots on Migration Routes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Suspended out off Mouth of Spawning Bays(same depth)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Green Weed Shoots at the Mouths of Bays"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Open Water near suspended Bait Schools"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Long Narrow Islands in-Line as Migration Edge"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Straight Walls with Rock Slides or Timber"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Wind Generated Current (Fwd & Back Flows)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Large Flats off Islands with Boulders"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small, Well Defined Structure Spots on Migration Routes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Boulder Piles on Tips of Spines and Points"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Roaming Whitefish or Ciscos in Deep Narrows"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep Rock Reefs"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Long and XL Points (Windward Side)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Rock Walls"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Rock and Weed Complexes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep Rock Reefs"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Windy Neck Down Areas Creating Current (& Backflows)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Saddles in Low Light"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Roaming Whitefish or Ciscos in Deep Narrows"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Rock Reefs with wind"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Isolated Shallow Bays with Scruff Weeds"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Above and Inside the First / Primary Break Line"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Neck Down Areas with Wind"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Mouths of Inlet Flows"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small, Well Defined Structure Spots on Migration Routes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Tight to Shore on Rocky, Mid-Lake Islands"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Mid-Lake Reefs (esp. with Wind)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shoreline Oriented Flats with Chunk Rock (Bill)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Long Narrow Islands in-Line as Migration Edge"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Large Flats off Ends of Islands near Deep Water"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Rock and Weed Complexes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Boulder Flats (Moose Rocks)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Windward Side of Long Points or Spines"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Boulder Fields"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Reefs with Wind (Tops at 5 - 12 ft)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Outside Weed Edge and Directly Adjacent Rock Shorelines (Brets Last Cast)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Island Clusters with Complex Saddles"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Open Water 150 - 200 yds off Structure"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Rock and Weed Complexes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Food Shelf Below the 2nd Break"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small, Well Defined Structure Spots on Migration Routes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Backflow Current Areas from Wind"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Windward Side of Long Points or Spines"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Outside Weed Edge and Directly Adjacent Rock Shorelines (Brets Last Cast)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Very Large, Deep Rock Reefs (20 - 30 fow)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Extended Points near In-Flows (CavChute)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Boulder Piles on Tips of Spines and Points"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Mid Lake Bars with Weeds"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Large, Mid Lake Flats Off Islands w/ Chunk Rock"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Small, Well Defined Structure Spots on Migration Routes"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Saddles (like Lost Boat)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Sand, Rock or Gravel Flats w/Ciscos Staging"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Off the edge of Deep Rock Reefs"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Large Flats off Ends of Islands near Deep Water"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Troll the Walls"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Boulder Flats (Moose Rocks)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Complex Rock and Weed Bars"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Steep Breaking Shorelines with Ciscos or Whitefish Staging"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Wind Driven Current in Narrows"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Shallow Rock Reefs near Deep Water (DryberryBigs)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep Water Basins"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep Water Neck Downs (i.e. Fergus Is. Cut)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Below the Chute (Dryberry, Abrams, Caviar)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep Water Granite Walls (ie Timber Is.)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Very Large - Reasonably Flat - Mid Lake - Reefs"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Above the Falls - Out and Off to the sides"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Deep holes in Current (Paw Landing Outflow)"
      },
      {
         "lakeType":"CADeepClear",
         "spotTypeDesc":"Complex Rock and Weed Bars"
      }
   ];

function LakeSpotDialog({ open, onClose, onSave, spot, lakeId, onDelete, lakeType }) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    typeDescription: '',
    latitude: '',
    longitude: '',
    promoCode: '',
    sponsorAdId: '',
    imageUrl: '',
    location: ['S'] // Default value
  });

  useEffect(() => {
    if (spot) {
      setFormData(prev => ({
        name: '',
        description: '',
        typeDescription: '',
        promoCode: '',
        sponsorAdId: '',
        imageUrl: '',
        location: ['S'],
        lakeId: lakeId,
        ...spot,
        location: spot.location ? (Array.isArray(spot.location) ? spot.location : [spot.location].filter(Boolean)) : ['S']
      }));
    } else {
      setFormData({
        name: '',
        description: '',
        typeDescription: '',
        latitude: '',
        longitude: '',
        promoCode: '',
        sponsorAdId: '',
        imageUrl: '',
        location: ['S'],
        lakeId: lakeId
      });
    }
  }, [spot, lakeId, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLocationChange = (e) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      location: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      latitude: Number(formData.latitude),
      longitude: Number(formData.longitude)
    });
  };

  // Filter spot types based on the current lakeType
  // Also dedup descriptions if there are duplicates for the same lakeType
  const filteredSpotTypes = React.useMemo(() => {
    if (!lakeType) return [];
    
    const types = ALL_SPOT_TYPES
      .filter(type => type.lakeType === lakeType)
      .map(type => type.spotTypeDesc);
      
    return [...new Set(types)];
  }, [lakeType]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{spot ? 'Edit Spot' : 'Add Spot'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              label="Description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
            <TextField
              label="Type Description"
              name="typeDescription"
              value={formData.typeDescription}
              onChange={handleChange}
              fullWidth
              select
            >
               {filteredSpotTypes.map((type) => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
              <MenuItem value="Custom">Custom (Type in Description)</MenuItem>
            </TextField>
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                label="Latitude"
                name="latitude"
                type="number"
                value={formData.latitude}
                fullWidth
                required
                disabled
                inputProps={{ step: "any" }}
              />
              <TextField
                label="Longitude"
                name="longitude"
                type="number"
                value={formData.longitude}
                fullWidth
                required
                disabled
                inputProps={{ step: "any" }}
              />
            </Box>

            <TextField
              label="Image URL"
              name="imageUrl"
              value={formData.imageUrl}
              onChange={handleChange}
              fullWidth
            />

            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                label="Promo Code"
                name="promoCode"
                value={formData.promoCode}
                onChange={handleChange}
                fullWidth
              />
              <TextField
                label="Sponsor Ad ID"
                name="sponsorAdId"
                value={formData.sponsorAdId}
                onChange={handleChange}
                fullWidth
              />
            </Box>
             
             <FormControl fullWidth>
                <InputLabel id="location-label">Location Code</InputLabel>
                <Select
                  labelId="location-label"
                  multiple
                  value={formData.location}
                  onChange={handleLocationChange}
                  input={<OutlinedInput label="Location Code" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip 
                          key={value} 
                          label={`${value} - ${LOCATION_OPTIONS.find(opt => opt.value === value)?.label || ''}`} 
                        />
                      ))}
                    </Box>
                  )}
                >
                  {LOCATION_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.value} - {option.label}
                    </MenuItem>
                  ))}
                </Select>
             </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {spot && spot.id && onDelete && (
             <Button onClick={() => onDelete(spot)} color="error" sx={{ mr: 'auto' }}>
              Delete
            </Button>
          )}
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default LakeSpotDialog;
